import Box from '@mui/material/Box';
import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';

import {ConfigConstant} from '../../constants/config';
import CustomValueList from '../CustomList/CustomValueList';
import DebounceSearchInput from '../SearchInput/SearchInput';

const ItemSelectorFilterMenu = ({
  currentFilter,
  addFilter,
  showMenuItemSelectBox,
  showSelectedDisabled,
  virtualLoadWidth,
  virtualLoadHeight,
}) => {
  const rawOptions = useSelector((store) => store.commonFilters[currentFilter?.key]) || [];

  const [options, setOptions] = useState(rawOptions);

  const [searchText, setSearchText] = useState('');

  const onSearchTextChange = (value) => {
    setSearchText(value);
  };

  const onClickMenu = (item) => {
    if (currentFilter?.selectType === ConfigConstant.FILTER_SELECT_TYPE.SINGLE) {
      if (currentFilter?.value === item?.code) {
        if (currentFilter?.isDeleteable) {
          addFilter({
            ...currentFilter,
            isApplied: false,
            displayValue: Array.isArray(currentFilter?.displayValue) ? [] : '',
            value: Array.isArray(currentFilter?.value) ? [] : '',
          });
        }
      } else {
        addFilter({
          ...currentFilter,
          isApplied: true,
          displayValue: Array.isArray(currentFilter?.displayValue) ? [item?.label] : item?.label,
          value: Array.isArray(currentFilter?.value) ? [item?.code] : item?.code,
        });
      }
    } else {
      if (currentFilter?.value?.includes(item?.code)) {
        if (currentFilter?.value?.length === 1) {
          if (currentFilter?.isDeleteable) {
            addFilter(
              {
                ...currentFilter,
                isApplied: false,
                displayValue: [],
                value: [],
              },
              false
            );
          }
        } else {
          addFilter(
            {
              ...currentFilter,
              isApplied: true,
              displayValue: currentFilter?.displayValue?.filter((ele) => ele !== item?.label),
              value: currentFilter?.value?.filter((ele) => ele !== item?.code),
            },
            false
          );
        }
      } else {
        const newDisplayValue = currentFilter?.displayValue || [];
        const newValue = currentFilter?.value || [];
        newDisplayValue.push(item?.label);
        newValue.push(item?.code);
        addFilter(
          {
            ...currentFilter,
            isApplied: true,
            displayValue: newDisplayValue,
            value: newValue,
          },
          false
        );
      }
    }
  };

  useEffect(() => {
    if (searchText.length > 2) {
      const filteredOptions = rawOptions.filter((option) =>
        option.label.toLowerCase().includes(searchText.toLowerCase())
      );
      setOptions(filteredOptions);
    } else {
      setOptions(rawOptions);
    }
  }, [rawOptions, searchText]);

  return (
    <>
      <Box sx={{position: 'sticky', top: 0, background: (theme) => theme.palette.white, zIndex: 2}}>
        <DebounceSearchInput
          placeholderText={'search'}
          value={searchText}
          onChange={onSearchTextChange}
          debounce={200}
        />
      </Box>
      <Box>
        <CustomValueList
          items={options}
          onClick={onClickMenu}
          currentFilter={currentFilter}
          showMenuItemSelectBox={showMenuItemSelectBox}
          showSelectedDisabled={showSelectedDisabled}
          virtualLoadWidth={virtualLoadWidth}
          virtualLoadHeight={virtualLoadHeight}
        />
      </Box>
    </>
  );
};

export default ItemSelectorFilterMenu;
